import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import Modal from "../../../../parts/modal-new";

const MyFitnessPalDiaryInfoModal = ({ diaryUrl, onOpen, onClose }) => {
  const { t } = useTranslation("athlete-portal");

  const handleClose = (event) => {
    event?.preventDefault();
    onClose();
  };

  return createPortal(
    <Modal
      className="mfp-diary-info-modal"
      customTitle={<h2>{t("nutritionPage.mfpDiary.infoModal.title")}</h2>}
      onClose={handleClose}
    >
      <div className="body">
        <p className="mfp-diary-info-modal__text">
          {t("nutritionPage.mfpDiary.infoModal.body")}
        </p>
        <p className="mfp-diary-info-modal__text">
          {t("nutritionPage.mfpDiary.infoModal.paste")}
        </p>
        <p className="mfp-diary-info-modal__text mfp-diary-info-modal__note">
          {t("nutritionPage.mfpDiary.infoModal.privacy")}
        </p>
      </div>
      <footer>
        <button type="button" data-button-type="secondary" onClick={onClose}>
          {t("nutritionPage.mfpDiary.infoModal.notNow")}
        </button>
        {/* biome-ignore lint/a11y/useSemanticElements: a real link so the new tab opens natively (no popup blocker); role only picks up button styles */}
        <a
          href={diaryUrl}
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          data-button-type="primary"
          onClick={onOpen}
        >
          {t("nutritionPage.mfpDiary.infoModal.open")}
        </a>
      </footer>
    </Modal>,
    document.body
  );
};

MyFitnessPalDiaryInfoModal.propTypes = {
  diaryUrl: PropTypes.string.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MyFitnessPalDiaryInfoModal;
